
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { name: '首页', href: '/' },
    { name: '主播合作', href: '/anchor-cooperation' },
    { name: '工厂合作', href: '/factory-cooperation' },
    { name: '品牌中心', href: '/brand-center' },
    { name: '溯源系统', href: '/traceability' },
    { name: '关于我们', href: '/about' }
  ];

  const handleNavClick = (href: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(href);
      // 确保页面滚动到顶部
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.location.href = href;
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg">
              <i className="ri-leaf-line text-white text-2xl"></i>
            </div>
            <div>
              <button
                onClick={() => handleNavClick('/')}
                className="cursor-pointer"
              >
                <h1 className="text-xl md:text-2xl font-bold text-blue-800" style={{ fontFamily: "Pacifico, serif" }}>南滇古茶</h1>
                <p className="text-xs md:text-sm text-gray-600">普洱茶产业生态赋能者</p>
              </button>
            </div>
          </div>

          {/* Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => handleNavClick(item.href)}
                className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium cursor-pointer whitespace-nowrap"
              >
                {item.name}
              </button>
            ))}
            <button onClick={() => handleNavClick('/cooperation')}>
              <Button variant="secondary" size="sm">
                合作申请
              </Button>
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            className="lg:hidden w-8 h-8 flex items-center justify-center"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-3">
              {navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => handleNavClick(item.href)}
                  className="text-base text-gray-700 hover:text-blue-600 transition-colors duration-200 py-2 cursor-pointer text-left whitespace-nowrap"
                >
                  {item.name}
                </button>
              ))}
              <div className="pt-2">
                <button onClick={() => handleNavClick('/cooperation')}>
                  <Button variant="secondary" size="sm">
                    合作申请
                  </Button>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
